import React, { Fragment } from 'react';

import ProjectListPage from 'src/sections/workspace/sections/projects/page';

import WorkspaceHelmet from '../../components/workspace-helmet';

import messages from './projects.i18n';

const WorkspaceProjectsRoute = () => {
  return (
    <Fragment>
      <WorkspaceHelmet pageTitle={messages.projectsPageHeader} />
      <ProjectListPage />
    </Fragment>
  );
};
export default WorkspaceProjectsRoute;
